import {
  REQUESTING_REFERRING_LOCATIONS,
  RECEIVE_REFERRING_LOCATIONS,
} from 'agent_portal/actions/ReferringLocationsActions';

const initialState = {
  isFetching: false,
  items: [],
  lastUpdated: 0,
};

export default function referringLocations(state = initialState, action) {
  switch (action.type) {
    case REQUESTING_REFERRING_LOCATIONS:
      return Object.assign({}, state, {
        isFetching: true,
      });

    case RECEIVE_REFERRING_LOCATIONS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.referringLocations,
        lastUpdated: action.receivedAt,
      });

    default:
      return state;
  }
}
